//About page view
import Barba from 'barba.js'
import $ from 'jquery';
import workThumbs from 'modules/workthumbs';
//Progressive from

const Work = Barba.BaseView.extend({
  namespace: 'work',
  screenWidth: window.innerWidth,
  onEnter(){
    /***** Work Thumbs *****/
    // var workThumbs = function() {
    //   $(".work-index ul a").hover(
    //     function() {
    //       var name = $(this).attr('id');
    //       var thumb = "#" + name + "-thumb";
    //       $(thumb).addClass( "visible" );
    //     }, function() {
    //       var name = $(this).attr('id');
    //       var thumb = "#" + name + "-thumb";
    //       $(thumb).removeClass( "visible" );
    //     }
    //   );
    // }

    workThumbs();

  },
  onEnterCompleted(){

  },
  onLeave(){
    this.destroy();
  },
  $el: null,
  _construct(){
  },
  destroy(){

  }
});
export default Work;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/work.js